var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-2"},[_c('div',{staticClass:"card m-2 shadow"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-fill"},[_c('KarinSearch')],1),_c('div',{staticClass:"float-end"},[_c('KarinPagination')],1)])]),_c('div',{staticClass:"card-body"},[_c('KarinTable')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }